<template>
    <!-- Page Footer-->
    <!-- Footer Default-->
    <footer class="section page-footer page-footer-default novi-background bg-cover text-left bg-gray-darker" v-bind:class="{ 'fixed-footer': isFixedFooter }">
        <div class="container container-wide">
            <div class="col-xs-15">
                <div class="col-xs-3"><a href="#" @click="trackFooterLinkClickEvent('https://www.alc.co.jp/policy/other/', 'foot_terms_of_service_click')">利用規約</a></div> <!-- Terms of Services -->
                <div class="col-xs-3 separator">|</div>
                <div class="col-xs-3"><a href="#" @click="trackFooterLinkClickEvent('https://www.alc.co.jp/policy/privacy/', 'foot_privacy_policy_click')">プライバシーポリシー</a></div> <!-- Privacy Policy -->
                <div class="col-xs-3 separator">|</div>
                <div class="col-xs-3"><a href="#" @click="trackFooterLinkClickEvent('https://eow-support.alc.co.jp/hc/ja/requests/new', 'foot_contact_us_click')">お問い合わせ</a></div> <!-- Contact Us -->
                <div class="col-xs-3 separator">|</div>
                <div class="col-xs-3"><a href="#" @click="trackFooterLinkClickEvent('/tokusho', 'foot_tokusho_click')"><p>特定商取引法に基づく表示</p></a></div> <!-- Display based on the Specified Commercial Transaction Law -->
                <div class="col-xs-3 separator">|</div>
                <div class="col-xs-3"><a href="#" @click="trackFooterLinkClickEvent('https://www.alc.co.jp/', 'foot_alc_home_click')">アルクのウェブサイト</a></div> <!-- ALC Website -->
                <div class="col-xs-3 separator">|</div>
                <div class="col-xs-3"><a href="#" @click="trackFooterLinkClickEvent('https://eowp-user.alc.co.jp/', 'foot_registration_center_click')">登録センター</a></div> <!-- Registration Center -->
            </div>
            <div class="footer-copyright">
                <p class="right">&#169; 2000 - {{copyrightDate}} <a href="#" @click="redirect('https://www.alc.co.jp/', 'foot_alc_copyright_click')">ALC PRESS INC.</a></p>
            </div>
        </div>
    </footer>
</template>

<style scoped>
footer{
    margin-top: auto;
    background-color: #f5f5f5!important;
    color: #333333!important;
    min-height: 141px;
    padding: 30px 0 30px !important;
}
footer a{
    color: #333333!important;
}
.footer-copyright {
    text-align: center;
    padding-top: 5px;
}
.col-xs-3 a {
    color: #ffffff;
    display: block;
    padding: 10px
}
.col-xs-3 a:hover {
    font-weight: bold !important;
    color: black!important;
}
.col-xs-15 {
    text-align: center;
    white-space: nowrap !important;
    max-width: 100%;
    overflow: hidden;
}

@media screen and (max-width: 789px) {
    .col-xs-3 {
        float: left !important;
        display: inline-flex !important;
        text-align: center;
    }
    .separator{
        position: relative;
        margin-top: 9px;
    }
}
@media screen and (min-width: 790px) {
    .col-xs-3 {
        float: none !important;
        display: inline-block !important;
        text-align: center;
    }
}

@media screen, (min-width: 789px) {
     .col-xs-15 {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      position: relative;
      align-content: center;
      text-align:center;
    }
      .separator{
      position: relative;
      margin-top: 9px;
    }
}

@media screen and (-webkit-min-device-pixel-ratio:0) {
    @media (min-width: 768px) and (max-width: 1024px)
        and (min-height: 801px) {
        .fixed-footer {
            width: 100%!important;
            left: 0!important;
            bottom: 0!important;
            flex: none !important;
            position: fixed !important;;
        }
    }
}
</style>

<script>
// Add here all imports
import { mapActions } from "vuex";

export default {
    data() {
        return {
            isFixedFooter: false,
            fixedFooterPages: ['/signin', '/impersonate']
        }
    },
    created() {
        if(this.fixedFooterPages.includes(this.$route.path)){
            this.isFixedFooter = true;
        }
    },
    computed: {
        copyrightDate: () => {
            let date = new Date();
            return date.getFullYear();
        }
    },
    methods: {
        ...mapActions({
            trackClickEvent: 'ga/trackClickEvent',
            trackOutboundClickEvent: 'ga/trackOutboundClickEvent'
        }),
        redirect(url, eventName){ 
            this.trackClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title, url: url});
        },
        trackFooterLinkClickEvent(url, eventName){
            this.trackOutboundClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title, url: url});
        }
    }
};
</script>